const contactSection = $('#contact-section');
const contactSwitcher = contactSection.find('.switch');
const contactFormPlacer = contactSection.find('.big-form-placer').eq(0);

const addContactInAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };
  const contactTL = gsap.timeline({ paused: true });

  contactTL.add(
    animateSectionTopperIn({
      sectionParent: contactSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );
  contactTL.add(elementInAnimationYWOpacity(contactSwitcher, '100%', 0, 1, 0.833, 0.833, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 0.2);
  //contactTL.add(addElementInAnimation(contactSwitcher, '100%', 0.833, 0).play(), 0.2);
  /*
  contactTL.add(animateFormIn(contactFormPlacer).play(), 0.633);
  contactTL.add(() => animateFormLines(contactSection, 0), 0.633);
  */

  return contactTL;
};

const contactTrigger = () => {
  const contactInTL = isDesktop() ? addContactInAnimation() : false;
  const contactInFormTL = gsap.timeline({ paused: true, onComplete: () => animateFormSwitch(contactSection) });
  if (isDesktop()) {
    contactInFormTL.add(animateFormIn(contactFormPlacer).play(), 0);
    contactInFormTL.add(() => animateFormLines(contactSection, 0), 0);
  }

  if(contactInTL){
    ScrollTrigger.create({
      trigger: contactSection,
      start: 'top top+=120%',
      end: 'top top+=20%',
      once: true,
      onUpdate: (self) => {
        contactInTL.progress(self.progress);
      },
    });
  }

  ScrollTrigger.create({
    trigger: contactSection,
    start: 'top bottom-=30%',
    end: 'top top',
    once: true,
    onEnter: () => {
      contactInFormTL.play();
    },
  });
};

/*
$(window).on('heroReady', function () {
contactTrigger();
});
*/

addSectionObserver(contactSection, contactTrigger);